import { MotivationUtil } from 'kuaidong-model'
import { RouteConfig } from 'vue-router'

// 2025秋季体育积分 → 直接跳转到 2026春季体育积分
export const IndexRoute: RouteConfig = {
  path: '/activity/autumn-points-2025',
  name: 'activity_autumn_points_2025',
  // component: () => import('./autumn-points/index.vue'),
  // props: (route) => ({ ...route.query, ...route.params }),
  // meta: {
  //   title: '2025秋季体育积分',
  // },
  redirect: (to) => ({ name: MotivationUtil.pointActivityCenterRouteName, query: to.query }),
}

// 2026春季体育积分, 在原有秋季体育积分的基础上修改
export const SpringPoints2026Route: RouteConfig = {
  path: '/activity/spring-points-2026',
  name: 'activity_spring_points_2026',
  component: () => import('./autumn-points/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026春季体育积分',
  },
}

export default [IndexRoute, SpringPoints2026Route]
